var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://causalanalysis.ai/"}},[_vm._v(_vm._s(_vm.$t("mainNav.link.support")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }